// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Base URL for static files (uploads)
const STATIC_BASE_URL = API_BASE_URL.replace('/api', '');

// Helper function to construct full URLs from relative paths
const getFullUrl = (relativePath) => {
  if (!relativePath) return '';
  
  // If it's already a full URL, return as is
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    return relativePath;
  }
  
  // If it starts with /uploads, construct full URL
  if (relativePath.startsWith('/uploads/')) {
    return `${STATIC_BASE_URL}${relativePath}`;
  }
  
  // If it doesn't start with /, add it
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `${STATIC_BASE_URL}${path}`;
};

export { API_BASE_URL, STATIC_BASE_URL, getFullUrl };